import React, {useEffect} from "react";
import "./style.scss";
import BuyFundedAc from "../BuyFundedAc";
import {useDispatch, useSelector} from "react-redux";
import {getPlans, setSelectedChallenge} from "../../../store/reducers/accountSlice";
import {useParams} from "react-router-dom";

function FundingEvaluationPublic() {
  const plans = useSelector((state) => state.account.plans.data);
  const selectedBrand = useSelector((state) => state.brand.selectedBrand);

  const {id} = useParams();
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(getPlans({selectedBrand}));
  }, []);
  useEffect(() => {
    dispatch(setSelectedChallenge(Number(id)));
  }, [plans, id]);

  useEffect(() => {
    document.body.style.overflow = "auto";
  }, [plans]);

  return (
    <div className="mainPageHolder-B public">
      <BuyFundedAc publicCheckout={true} />
    </div>
  );
}

export default FundingEvaluationPublic;
